<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <!-- 头部 -->
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>华胤建造</h1>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="tabs tabs-style-linebox hidden-xs">
      <div class="zznav">
        <ul class="zzitem">
          <li><a @click="forId('hysg')">华胤施工</a></li>
          <li><a @click="forId('cpjs')">产品介绍</a></li>
        </ul>
      </div>
    </div>
    <!-- 小滚轮 -->
    <div id="ss_menu">
      <div>
        <i
          ><a @click="forId('cpjs')">产品<br />介绍</a></i
        >
      </div>
      <div>
        <i
          ><a @click="forId('hysg')">华胤<br />施工</a></i
        >
      </div>
      <div class="menu">
        <div class="share" id="ss_toggle" data-rot="180">
          <div class="circle"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <!-- 华胤施工 -->
    <div class="jzcontainer" id="hysg">
      <div class="jzleft">
        <h1 class="jzh">华胤施工</h1>
        <p class="jzp">
          华胤在中国已经成功完成2000多个工程项目，积累了丰富的项目管理经验。<br />采用项目经理管理体系，高效地进行工程管理及现场服务。<br />项目经理与业主、设计院、监理、政府相关部门和其他承建商保持密切的工作关系，使得项目实施顺利进行。<br />具体有效的措施，保证现场工地对安全的要求。<br />完善的售后服务，保证客户无后顾之忧。
        </p>
      </div>
      <div class="jzright">
        <img v-lazy="hyjz1" alt="Lazy-loaded Image" class="jzimg" />
      </div>
    </div>
    <!-- 产品介绍 -->
    <div id="cpjs">
      <h1 class="jzcph">产品介绍</h1>
    </div>

    <div class="jzcp">
      <div class="visible-xs">
        <div class="cd-image-block">
          <ul class="cd-images-list">
            <li class="is-selected">
              <a href="#0">
                <h2>通风系统</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>采光系统</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>楼层系统</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>墙面系统</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>屋面系统</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>檩条围梁</h2>
              </a>
            </li>
            <li>
              <a href="#0">
                <h2>主钢系统</h2>
              </a>
            </li>
            <li>
              <a href="#0">
                <h2>预制结构</h2>
              </a>
            </li>
          </ul>
          <!-- .cd-images-list -->
          <ul class="block-navigation">
            <li>
              <button class="cd-prev inactive jzbutton">&larr; 上一页</button>
            </li>
            <li><button class="cd-next jzbutton">下一页 &rarr;</button></li>
          </ul>
          <!-- .block-navigation -->
        </div>
        <!-- .cd-image-block -->

        <div class="cd-content-block">
          <ul>
            <li class="is-selected">
              <div>
                <h2>通风系统</h2>
                <p>华胤自然通风系统</p>
                <p>
                  利用室内温差产生热动力，以及室内外自然风形成的风动力，从建筑物的低层墙壁上的空气入口吸入新鲜空气，并将内部热气废气，及有毒气体由通风器出口排出，从而达到排气效果。<br />
                  与机械通风系统比较有以下列优势：经济成本低,自动调节换气量,宁静无震动,专业设计，安装快捷方便
                </p>
              </div>
            </li>

            <li>
              <div>
                <h2>采光系统</h2>

                <p>采光板</p>

                <p>
                  采光板是一种用于建筑物的材料，可以提供高效且无害的自然照明。它的设计和结构使得室内可以获得充足的自然光线，从而减少对人工照明的依赖。与传统的照明设备相比，采光板无需使用电力，因此可以降低能源消耗和电费支出。<br />
                  此外，采光板的表面覆膜具有一定的功能性。它可以隔绝99.9%的紫外线，从而有效地保护室内的人员和物品免受紫外线的伤害。同时，表面覆膜还具有防老化和防变色的特性，可以保持板材的外观和性能长时间稳定，延长其使用寿命。<br />
                  透光率：透明色(70%)；乳白色(58%)。
                </p>
              </div>
            </li>

            <li>
              <div>
                <h2>楼层系统</h2>

                <p>
                  具备与低层预制钢结构系统相同特点，相对于传统的钢筋混凝土结构，多层钢结构系统更有效缩短工期，控制施工品质。<br />
                  楼层厚度与柱的尺寸可减少到最低程度，从而减少建筑高度，提供更多使用空间，减少了建筑空间，节约了不必要的热能和空调供应。<br />
                  轻巧的结构减轻了对地基的荷载，从而节省了地基成本。<br />
                  地板可由华胤组合楼层板在现场与混凝土浇筑而成。在任何气候条件下都能快速施工的楼承板系统，以其质轻，及强度和重量对比性能高，耐用美观等特点，长期以来一直为设计师们所肯定。
                </p>

                <p>
                  FE-2W楼承板<br />
                  华胤FE-2W组合楼承板，产品设计中包含华胤专利技术（ZL99241901.1），专为办公室及荷载较轻的工业建筑夹层，或对层高及楼板厚度有特殊要求的建筑而研发。
                </p>

                <p>
                  FE-3W楼承板<br />
                  华胤3W组合楼承板系统，产品设计中包括两项华胤专利技术（ZL00261986.5
                  ZL99241801.1）专为重荷载或梁间距较大的重型楼面，和多高层建筑而研发。
                </p>
              </div>
            </li>

            <li>
              <div>
                <h2>墙面系统</h2>

                <p>
                  CDII墙面系统<br />
                  螺丝外露，普遍经济型，安装便捷，适用于各类建筑<br />
                  RD墙面系统<br />
                  独特的波峰，在每边墙面同时形成不同竖向阴影，螺丝半隐藏在波槽内，整面墙外观清晰大方
                  普遍经济型，安装便捷，适用于各类建筑<br />
                  PD墙面系统<br />
                  PD墙板使用互扣隐藏连接方式，表面无螺丝暴露，平整高雅
                  墙身40毫米厚的空间，允许夹入较厚的保温材料提高保温效能<br />
                  PU50/MW60三明治系统<br />
                  板面由两层彩色钢板作面板，以连续高压发泡注入阻燃聚氨酯泡沫，填充岩棉。提供PU50聚氨酯和MW60岩棉两种材质的荚芯板，提供平滑的特殊低凹槽和锯齿条纹。<br />
                  CP双层墙面板系统<br />
                  由华胤任一种屋面板与LND内层板组成，内夹玻璃棉保温层，内层板能为屋面内层提供光洁之表面，同时保护屋面保温层，内层板是用于屋面及墙面的低波峰。
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>屋面系统</h2>
                <p>
                  SD屋面系统<br />
                  使用特配的封闭式滑动固定座与360°双层卷边锁缝气密连接，屋面整体固定后形成一块高气密的膜板，抗台风能力强，保温效果佳，防漏性能优,
                  热胀冷缩时，通过固定座预设的滑动夹移动,有效的消除热胀冷缩对结构产生的影响<br />

                  LD屋面系统<br />
                  LD屋面板由两个特配的固定座以互扣及三明治方式连接固定
                  具有完美的防漏抗风雪能力和超强承载力
                  热胀冷缩时可移动钢板，避免钢板损坏
                  <br />

                  KD屋面系统<br />
                  使用特配的隐藏式固定座与钢板互扣合连接的屋面系统
                  抗风能力强，防漏性能好 热胀冷缩时钢板可移动，避免钢板损坏
                  <br />

                  CP双层屋面板系统<br />
                  使Cp双层屋面板系统由华胤任一种屋面板与LND内层板组成，内夹玻璃棉保温层，内层板能为屋面内层提供光洁之表面，同时保护屋面保温层<br />

                  CD II屋面系统<br />
                  螺丝直接穿透钢板固定系统
                  普遍经济型的屋面系统，适用于宽度窄的屋面
                  特殊的连接方式，有效地防风及防漏
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>檩条围梁</h2>
                <p>
                  次结构系统是建筑物屋面板和墙面板的连接支撑，通常安装在屋梁和柱子上。在这个系统中，檩条是一种重要的组成部分，它是连接屋面板和墙面板的横向支撑结构。<br />

                  檩条的材质通常是高强度连续热浸镀锌或镀铝锌钢板，这种材质具有很好的耐腐蚀性能，可以保证檩条在恶劣环境下也能长期使用。此外，檩条的表面光洁、美观，可以为屋面和墙面提供更好的外观效果。<br />

                  檩条的类型主要有“C”型和“Z”型两种。其中，“C”型檩条的截面形状类似于字母“C”，它通常用于支撑屋面板。而“Z”型檩条的截面形状类似于字母“Z”，它通常用于支撑墙面板。这两种檩条的类型可以根据建筑物的具体需求进行选择和安装。
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>主钢系统</h2>
                <p>
                  主结构是支撑整个钢结构建筑的钢梁与钢柱，由H型钢焊接而成。<br />
                  材料按工程设计，采用国家标准的Q235B或Q345B钢材。<br />
                  根据每项工程的特殊情况设计，提供多种框架形式供选择。<br />
                  先进的自动焊接设备，确保焊缝品质及构件质量达到国家标准。<br />
                  采用进口多方向喷珠除锈设备，确保锈渍彻底清除。<br />
                  表面喷涂防锈底漆，确保钢构得到最佳防锈功能。
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>预制结构</h2>
                <p>
                  低层预制钢结构系统是一种现代化建筑系统，所有材料以钢为主，通过先进的设计软件优化设计，在工厂经过高精密加工而成，现场类似于搭积木般通过连接件拼装而成，无需任何现场焊接、加工。<br />
                  特点：工期短，质量易控制，维修低，实用面积大，柱距可按生产工艺布置，外观具现代化美感，易扩建。<br />
                  适用于各行业的厂房、物流仓库及飞机库、造船厂等大面积的、大跨度建筑。
                </p>
              </div>
            </li>
          </ul>

          <button class="cd-close jzbutton">Close</button>
        </div>
      </div>
      <div class="hidden-xs">
        <div class="container conHeight">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>通风系统</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz2" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <h3>华胤自然通风系统</h3>
              <p>
                利用室内温差产生热动力，以及室内外自然风形成的风动力，从建筑物的低层墙壁上的空气入口吸入新鲜空气，并将内部热气废气，及有毒气体由通风器出口排出，从而达到排气效果。<br />
                与机械通风系统比较有以下列优势：经济成本低,自动调节换气量,宁静无震动,专业设计，安装快捷方便
              </p>
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>采光系统</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <h3>采光板</h3>
              <p>
                采光板是一种用于建筑物的材料，可以提供高效且无害的自然照明。它的设计和结构使得室内可以获得充足的自然光线，从而减少对人工照明的依赖。与传统的照明设备相比，采光板无需使用电力，因此可以降低能源消耗和电费支出。<br />
                此外，采光板的表面覆膜具有一定的功能性。它可以隔绝99.9%的紫外线，从而有效地保护室内的人员和物品免受紫外线的伤害。同时，表面覆膜还具有防老化和防变色的特性，可以保持板材的外观和性能长时间稳定，延长其使用寿命。<br />
                透光率：透明色(70%)；乳白色(58%)。
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz3" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>楼层系统</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz4" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <h3>多层系统</h3>
              <p>
                具备与低层预制钢结构系统相同特点，相对于传统的钢筋混凝土结构，多层钢结构系统更有效缩短工期，控制施工品质。<br />
                楼层厚度与柱的尺寸可减少到最低程度，从而减少建筑高度，提供更多使用空间，减少了建筑空间，节约了不必要的热能和空调供应。<br />
                轻巧的结构减轻了对地基的荷载，从而节省了地基成本。<br />
                地板可由华胤组合楼层板在现场与混凝土浇筑而成。在任何气候条件下都能快速施工的楼承板系统，以其质轻，及强度和重量对比性能高，耐用美观等特点，长期以来一直为设计师们所肯定。
              </p>
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>墙面系统</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <p>
                CDII墙面系统<br />
                螺丝外露，普遍经济型，安装便捷，适用于各类建筑<br />
                RD墙面系统<br />
                独特的波峰，在每边墙面同时形成不同竖向阴影，螺丝半隐藏在波槽内，整面墙外观清晰大方
                普遍经济型，安装便捷，适用于各类建筑<br />
                PD墙面系统<br />
                PD墙板使用互扣隐藏连接方式，表面无螺丝暴露，平整高雅
                墙身40毫米厚的空间，允许夹入较厚的保温材料提高保温效能<br />
                PU50/MW60三明治系统<br />
                板面由两层彩色钢板作面板，以连续高压发泡注入阻燃聚氨酯泡沫，填充岩棉。提供PU50聚氨酯和MW60岩棉两种材质的荚芯板，提供平滑的特殊低凹槽和锯齿条纹。<br />
                CP双层墙面板系统<br />
                由华胤任一种屋面板与LND内层板组成，内夹玻璃棉保温层，内层板能为屋面内层提供光洁之表面，同时保护屋面保温层，内层板是用于屋面及墙面的低波峰。
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz5" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>屋面系统</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz6" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <p>
                SD屋面系统<br />
                使用特配的封闭式滑动固定座与360°双层卷边锁缝气密连接，屋面整体固定后形成一块高气密的膜板，抗台风能力强，保温效果佳，防漏性能优,
                热胀冷缩时，通过固定座预设的滑动夹移动,有效的消除热胀冷缩对结构产生的影响<br />

                LD屋面系统<br />
                LD屋面板由两个特配的固定座以互扣及三明治方式连接固定
                具有完美的防漏抗风雪能力和超强承载力
                热胀冷缩时可移动钢板，避免钢板损坏
                <br />

                KD屋面系统<br />
                使用特配的隐藏式固定座与钢板互扣合连接的屋面系统
                抗风能力强，防漏性能好 热胀冷缩时钢板可移动，避免钢板损坏
                <br />

                CP双层屋面板系统<br />
                使Cp双层屋面板系统由华胤任一种屋面板与LND内层板组成，内夹玻璃棉保温层，内层板能为屋面内层提供光洁之表面，同时保护屋面保温层<br />

                CD II屋面系统<br />
                螺丝直接穿透钢板固定系统
                普遍经济型的屋面系统，适用于宽度窄的屋面
                特殊的连接方式，有效地防风及防漏
              </p>
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>檩条围梁</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <h3>次结构系统</h3>
              <p>
                次结构系统是建筑物屋面板和墙面板的连接支撑，通常安装在屋梁和柱子上。在这个系统中，檩条是一种重要的组成部分，它是连接屋面板和墙面板的横向支撑结构。<br />

                檩条的材质通常是高强度连续热浸镀锌或镀铝锌钢板，这种材质具有很好的耐腐蚀性能，可以保证檩条在恶劣环境下也能长期使用。此外，檩条的表面光洁、美观，可以为屋面和墙面提供更好的外观效果。<br />

                檩条的类型主要有“C”型和“Z”型两种。其中，“C”型檩条的截面形状类似于字母“C”，它通常用于支撑屋面板。而“Z”型檩条的截面形状类似于字母“Z”，它通常用于支撑墙面板。这两种檩条的类型可以根据建筑物的具体需求进行选择和安装。
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz7" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>主钢系统</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz8" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <h3>主结构系统</h3>
              <p>
                主结构是支撑整个钢结构建筑的钢梁与钢柱，由H型钢焊接而成。
                材料按工程设计，采用国家标准的Q235B或Q345B钢材。
                根据每项工程的特殊情况设计，提供多种框架形式供选择。<br />
                先进的自动焊接设备，确保焊缝品质及构件质量达到国家标准。
                采用进口多方向喷珠除锈设备，确保锈渍彻底清除。
                表面喷涂防锈底漆，确保钢构得到最佳防锈功能。
              </p>
            </div>
          </div>
        </div>
        <div class="container conHeight">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>预制结构</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <h3>低层预制钢结构系统</h3>
              <p>
                低层预制钢结构系统是一种现代化建筑系统，所有材料以钢为主，通过先进的设计软件优化设计，在工厂经过高精密加工而成，现场类似于搭积木般通过连接件拼装而成，无需任何现场焊接、加工。<br />
                特点：工期短，质量易控制，维修低，实用面积大，柱距可按生产工艺布置，外观具现代化美感，易扩建。
                适用于各行业的厂房、物流仓库及飞机库、造船厂等大面积的、大跨度建筑。
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz9" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- .cd-content-block -->
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  mounted() {
    // 产品介绍
    $(document).ready(function ($) {
      //store DOM elements
      var imageWrapper = $('.cd-images-list'),
        imagesList = imageWrapper.children('li'),
        contentWrapper = $('.cd-content-block'),
        contentList = contentWrapper.children('ul').eq(0).children('li'),
        blockNavigation = $('.block-navigation'),
        blockNavigationNext = blockNavigation.find('.cd-next'),
        blockNavigationPrev = blockNavigation.find('.cd-prev'),
        //used to check if the animation is running
        animating = false

      //on mobile - open a single project content when selecting a project image
      imageWrapper.on('click', 'a', function (event) {
        event.preventDefault()
        var device = MQ()
        console.log(device)
        device == 'mobile' &&
          updateBlock(imagesList.index($(this).parent('li')), 'mobile')
      })

      //on mobile - close visible project when clicking the .cd-close btn
      contentWrapper.on('click', '.cd-close', function () {
        var closeBtn = $(this)
        if (!animating) {
          animating = true

          closeBtn
            .removeClass('is-scaled-up')
            .one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentWrapper
                  .removeClass('is-visible')
                  .one(
                    'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                    function () {
                      animating = false
                    }
                  )

                $('.cd-image-block').removeClass('content-block-is-visible')
                closeBtn.off(
                  'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'
                )
              }
            )
        }
      })

      //on desktop - update visible project when clicking the .block-navigation
      blockNavigation.on('click', 'button', function () {
        var direction = $(this),
          indexVisibleblock = imagesList.index(
            imageWrapper.children('li.is-selected')
          )

        if (!direction.hasClass('inactive')) {
          var index = direction.hasClass('cd-next')
            ? indexVisibleblock + 1
            : indexVisibleblock - 1
          updateBlock(index)
        }
      })

      //on desktop - update visible project on keydown
      $(document).on('keydown', function (event) {
        var device = MQ()
        console.log(event.which)
        if (
          event.which == '39' &&
          !blockNavigationNext.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to next project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) + 1
          )
        } else if (
          event.which == '37' &&
          !blockNavigationPrev.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to previous project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) - 1
          )
        }
      })

      function updateBlock(n, device) {
        if (!animating) {
          animating = true
          var imageItem = imagesList.eq(n),
            contentItem = contentList.eq(n)

          classUpdate($([imageItem, contentItem]))

          if (device == 'mobile') {
            contentItem.scrollTop(0)
            $('.cd-image-block').addClass('content-block-is-visible')
            contentWrapper
              .addClass('is-visible')
              .one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function () {
                  contentWrapper.find('.cd-close').addClass('is-scaled-up')
                  animating = false
                }
              )
          } else {
            contentList.addClass('overflow-hidden')
            contentItem.one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentItem.siblings().scrollTop(0)
                contentList.removeClass('overflow-hidden')
                animating = false
              }
            )
          }

          //if browser doesn't support transition
          if ($('.no-csstransitions').length > 0) animating = false

          updateBlockNavigation(n)
        }
      }

      function classUpdate(items) {
        items.each(function () {
          var item = $(this)
          item
            .addClass('is-selected')
            .removeClass('move-left')
            .siblings()
            .removeClass('is-selected')
            .end()
            .prevAll()
            .addClass('move-left')
            .end()
            .nextAll()
            .removeClass('move-left')
        })
      }

      function updateBlockNavigation(n) {
        n == 0
          ? blockNavigationPrev.addClass('inactive')
          : blockNavigationPrev.removeClass('inactive')
        n + 1 >= imagesList.length
          ? blockNavigationNext.addClass('inactive')
          : blockNavigationNext.removeClass('inactive')
      }

      function MQ() {
        return window
          .getComputedStyle(imageWrapper.get(0), '::before')
          .getPropertyValue('content')
          .replace(/'/g, '')
          .replace(/"/g, '')
          .split(', ')
      }
    })
  },
  data() {
    return {
      hyjz1: require('@/components/img/hyjz/hysg.jpg'),
      hyjz2: require('@/components/img/hyjz/cpjs1.jpg'),
      hyjz3: require('@/components/img/hyjz/cpjs2.jpg'),
      hyjz4: require('@/components/img/hyjz/cpjs3.jpg'),
      hyjz5: require('@/components/img/hyjz/cpjs4.jpg'),
      hyjz6: require('@/components/img/hyjz/cpjs5.jpg'),
      hyjz7: require('@/components/img/hyjz/cpjs6.jpg'),
      hyjz8: require('@/components/img/hyjz/cpjs7.jpg'),
      hyjz9: require('@/components/img/hyjz/cpjs8.jpg'),
    }
  },
  methods:{
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
  }
}
</script>

<style scoped>
/* 产品介绍高度 */
.conHeight {
  height: 80vh;
}

#hysg,
#cpjs,
#hyzp {
  margin-top: -83px;
  padding-top: 83px;
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hyjz/one1.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 40px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 12px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: -75px;
  left: -25px;
}

#ss_menu div:nth-child(2) {
  top: -25px;
  left: -75px;
}

/* #ss_menu div:nth-child(3) {
  top: -130px;
  left: 0px;
} */
/* hysg */
.jzcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.jzh {
  text-align: center;
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: #262626 solid 1px;
}
.jzp {
  font-weight: 400;
  font-size: 20px;
}
.jzleft {
  flex: 1;
  margin: 20px;
  padding: 20px;
  background-color: rgba(250, 250, 250, 0.1);
  /* text-align: center;
    line-height: auto; */
  color: #000;
  /* box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px; */
}

.jzright {
  flex: 1;
  margin: 20px;
  padding: 20px;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.jzimg {
  max-width: 100%;
  height: auto;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}
.jzcp {
  width: 99vw;
  height: 80vh;
}
.hyp {
  font-size: 20px;
  font-weight: 400;
}
@media (max-width: 768px) {
  .hyp {
    font-size: 14px;
    font-weight: 400;
  }
  .jzleft,
  .jzright {
    flex: 100%;
  }

  .jzleft {
    order: 1;
    margin: 0;
  }
  .jzh {
    text-align: center;
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  .jzp {
    font-weight: 100;
    font-size: 1.25em;
  }
  .jzright {
    order: 2;
  }
  .jzcp {
    width: 100vw;
    height: auto;
  }
  .jzcph {
    font-size: 35px !important;
    font-weight: 500 !important;
  }
}
/* 产品内容 */
/* -------------------------------- 

Images block

-------------------------------- */
.jzcph {
  text-align: center;
  padding: 30px 0;
  font-size: 50px;
  font-weight: 600;
  border-top: #000 solid 1px;
  border-bottom: #000 solid 1px;
}
.cd-image-block {
  position: relative;
}
.cd-image-block::before {
  /* this is the layer used to cover the .cd-image-block when the content block becomes visible - mobile only */
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(52, 54, 66, 0.6);
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s;
}
.cd-image-block.content-block-is-visible::before {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s;
}
@media only screen and (min-width: 768px) {
  .cd-image-block::before {
    display: none;
  }
}

.cd-images-list::before {
  /* never visible - this is used in jQuery to check the current MQ */
  content: 'mobile';
  display: none;
}
.cd-images-list > li {
  height: 250px;
  background: #979c9c url(@/components/img/hyjz/jz1.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(2) {
  background: #464d75 url(@/components/img/hyjz/jz2.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(3) {
  background: #982b3c url(@/components/img/hyjz/jz3.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(4) {
  background: #338899 url(@/components/img/hyjz/jz4.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(5) {
  background: #f55555 url(@/components/img/hyjz/jz5.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(6) {
  background: #a0fe65 url(@/components/img/hyjz/jz6.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(7) {
  background: #f6ceec url(@/components/img/hyjz/jz7.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(8) {
  background: #1d6fa3 url(@/components/img/hyjz/jz8.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li > a {
  /* used to vertically align the h2 child -  mobile version only */
  display: table;
  height: 100%;
  width: 100%;
}
.cd-images-list h2 {
  /* used to vertically align h2 -  mobile version only */
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 3rem;
  color: #ffffff;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media only screen and (min-width: 768px) {
  .cd-images-list::before {
    /* never visible - this is used in jQuery to check the current MQ */
    content: 'desktop';
  }
  .cd-images-list > li > a {
    display: block;
    padding: 4em 3em;
    cursor: default;
    pointer-events: none;
  }
  .cd-images-list h2 {
    font-size: 5.5rem;
    text-align: left;
  }
}

/* -------------------------------- 

Content block

-------------------------------- */
.cd-content-block {
  /* move the block outside the viewport (to the right) - mobile only */
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -ms-transform: translateX(100%);
  -o-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}
.cd-content-block.is-visible {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
  -o-transform: translateX(0);
  transform: translateX(0);
}
@media screen and (max-width: 768px) {
  .cd-content-block.is-visible {
    margin-top: 56px;
  }
}
.cd-content-block > ul {
  border: 1px solid black;
  height: 100%;
}
.cd-content-block > ul > li {
  position: absolute;
  height: 100%;
  padding: 1em;
  /* overflow-y: scroll; */
  background-color: #ffffff;
  opacity: 0;
  visibility: hidden;
}
.cd-content-block > ul > li.is-selected {
  /* this is the selected content */
  position: relative;
  opacity: 1;
  visibility: visible;
  -webkit-overflow-scrolling: touch;
}
.cd-content-block h2 {
  line-height: 1.2;
  font-weight: 700;
  font-size: 2.3rem;
  margin-bottom: 1em;
}
.cd-content-block p {
  margin-bottom: 1em;
  line-height: 1.3;
  color: #85868d;
  font-size: 14px;
}
.cd-content-block .cd-close {
  /* 'X' icon to close the content block -  mobile only */
  position: fixed;
  top: 0;
  right: 0;
  height: 44px;
  width: 44px;
  /* image replacement */
  overflow: hidden;
  text-indent: 100%;
  white-space: nowrap;
  color: transparent;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  transition: transform 0.2s;
}
.cd-content-block .cd-close::after,
.cd-content-block .cd-close::before {
  /* these are the 2 lines of the 'X' icon */
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: 24px;
  background-color: #343642;
  /* Force Hardware Acceleration */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}
.cd-content-block .cd-close::after {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}
.cd-content-block .cd-close::before {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  transform: translateX(-50%) translateY(-50%) rotate(-45deg);
}
.cd-content-block .cd-close.is-scaled-up {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}
.no-touch .cd-content-block .cd-close.is-scaled-up:hover {
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -ms-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
}
@media only screen and (min-width: 768px) {
  .cd-content-block {
    /* reset style */
    position: static;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-content-block p {
    margin-bottom: 1em;
    line-height: 1.6;
    color: #85868d;
    font-size: 20px;
  }
  .cd-content-block > ul > li {
    /* reset style */
    opacity: 1;
    visibility: visible;
    padding: 2em;
  }
  .cd-content-block > ul > li.overflow-hidden {
    /* this class is used during the animation (slider change) to hide the scrolling bar */
    overflow: hidden;
  }
  .cd-content-block h2 {
    font-size: 3rem;
  }
  .cd-content-block .cd-close {
    display: none;
  }
}

/* ---------------------------------------------- 

Desktop slider - both image and content blocks

---------------------------------------------- */
@media only screen and (min-width: 768px) {
  .cd-image-block {
    /* slider style - desktop version only */
    width: 40%;
    float: left;
    height: 80vh;
    overflow: hidden;
  }
  .cd-content-block {
    /* slider style - desktop version only */
    width: 60%;
    float: left;
    height: 80vh;
    overflow: hidden;
  }
  .cd-image-block > ul,
  .cd-content-block > ul {
    position: relative;
    height: 100%;
  }
  .cd-image-block > ul > li,
  .cd-content-block > ul > li {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    /* Force Hardware Acceleration */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    /* by default, the items are moved to the right - relative to their parent elements */
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
    transform: translateX(100%);
    -webkit-transition: -webkit-transform 0.5s;
    -moz-transition: -moz-transform 0.5s;
    transition: transform 0.5s;
  }
  .cd-image-block > ul > li.is-selected,
  .cd-content-block > ul > li.is-selected {
    /* this is the visible item */
    position: absolute;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-image-block > ul > li.move-left,
  .cd-content-block > ul > li.move-left {
    /* this is the item hidden on the left */
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
/* -------------------------------- 

Slider navigation

-------------------------------- */
.block-navigation {
  /* this is the slider navigation - desktop version only */
  display: none;
}
@media only screen and (min-width: 768px) {
  .block-navigation {
    display: block;
    position: absolute !important;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 39px !important;
  }
  .block-navigation::after {
    clear: both;
    content: '';
    display: table;
  }
  .block-navigation li {
    position: static !important;
    width: 50% !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    -webkit-transition: background 0.2s;
    -moz-transition: background 0.2s;
    transition: background 0.2s !important;
    transform: translateX(0) !important;
  }
  .block-navigation li:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .block-navigation li:first-of-type {
    float: left;
  }
  .block-navigation li:last-of-type {
    float: right;
  }
  .block-navigation button {
    display: block;
    height: 100%;
    width: 100%;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .block-navigation button.inactive {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

/* -------------------------------- 

Javascript disabled

-------------------------------- */
@media only screen and (min-width: 768px) {
  .no-js .cd-content-block {
    display: none;
  }

  .no-js .cd-image-block {
    width: 100%;
    overflow: visible;
  }

  .no-js .cd-images-list::after {
    clear: both;
    content: '';
    display: table;
  }

  .no-js .cd-images-list > li {
    position: static;
    width: 50%;
    float: left;
    height: 400px;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .no-js .cd-images-list > li.is-selected {
    position: static;
  }

  .no-js .cd-images-list > li > a {
    cursor: pointer;
    pointer-events: auto;
  }

  .no-js .block-navigation {
    display: none;
  }
}
.jzbutton {
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: none;
  font-size: 1.6rem;
}
/* 产品展示 */
:root {
  --color-primary: #000;
  --color-secondary: #fff;
  --color-text: #333;
  --font-size-title: 2rem;
  --font-size-subtitle: 1.5rem;
  --font-size-text: 1rem;
}

.container {
  padding: 0;
  margin: 0;
  width: 100%;
  position: relative;
}

.container .content {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  width: 90vw;
  display: flex;
}

.container .content .img-container {
  float: left;
  margin-right: 20px;
}

.container .content .img-container img {
  width: 40vw;
  height: 60vh;
}

.container .content .text-container {
  border: 1px solid #000;
  border-radius: 10px;
  float: right;
}
.container .content .text-container h3 {
  padding: 10px;
  margin: 0;
  text-align: center;
  font-size: 24px;
}
.container .content .text-container p {
  padding: 15px;
  font-size: 18px;
  line-height: 1.6;
}
.container .content .img-container img {
  border: 5px solid var(--color-primary);
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}
.container {
  background: linear-gradient(
    to bottom,
    var(--color-primary),
    var(--color-secondary)
  );
}
.box {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  background-color: #fff;
  width: 95vw;
  padding: 5px;
  border: 2px solid #000;
  text-align: center;
}

.box:before,
.box:after {
  content: '•';
  position: absolute;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #000;
  border: 2px solid #000;
  line-height: 12px;
  top: 5px;
  text-align: center;
}

.box:before {
  left: 5px;
}

.box:after {
  right: 5px;
}

.box .box-inner {
  position: relative;
  border: 2px solid #000;
}

.box .box-inner:before,
.box .box-inner:after {
  content: '•';
  position: absolute;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #000;
  border: 2px solid #000;
  line-height: 12px;
  bottom: -2px;
  text-align: center;
}

.box .box-inner:before {
  left: -2px;
}

.box .box-inner:after {
  right: -2px;
}
.box .box-inner h1 {
  margin: 10px 0;
  font-weight: 20px !important;
}
p {
  margin: 0 !important;
}
@media screen and (min-width: 2000px) {
  .jzh {
    font-size: 60px;
    margin-bottom: 60px;
    padding-bottom: 60px;
  }
  .jzp {
    font-size: 30px;
  }
  .jzleft {
    margin: 60px;
    padding: 60px;
  }
  .jzimg {
    height: 600px;
    width: 100%;
  }
  .jzcph {
    font-size: 60px;
  }
  .box .box-inner h1 {
    margin: 20px 0;
  }
  .container .content .text-container h3 {
    font-size: 30px;
  }
  .container .content .text-container p {
    font-size: 25px;
  }
  .conHeight {
    height: 67vh;
  }
  .container .content .img-container img {
    height: 55vh;
  }
  /* 头部 */
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem li a {
    margin: 0 50px;
    font-size: 25px;
  }
}
</style>
